import { Link } from 'react-router-dom'
import { FaBriefcase, FaGraduationCap, FaHeart, FaUsers, FaHandshake, FaEnvelope, FaMapMarkerAlt, FaClock, FaCheckCircle } from 'react-icons/fa'
import styles from './Careers.module.css'

const Careers = () => {
  const vacancies = [
    {
      id: 1,
      title: "Activiteitenbegeleider Dagbesteding",
      type: "Parttime / Fulltime",
      location: "Hengelo",
      hours: "16-24 uur per week",
      description: "Ben jij creatief, organiseer je graag activiteiten voor multiculturele ouderen en werk je met hart en ziel? Kom ons team versterken!",
      requirements: [
        "Minimaal MBO-4 diploma zoals: Activiteitenbegeleiding, Sociaal Cultureel Werk, Maatschappelijke Zorg of Social Work",
        "Suryoyo en/of Arabisch spreken is een pré",
        "Creatief, initiatiefrijk en flexibel",
        "Ervaring met groepsbegeleiding en/of ouderenzorg (pre)",
        "Cultureel sensitief en communicatief vaardig",
        "Teamplayer met positieve instelling"
      ],
      offer: [
        "Vrijheid om eigen activiteiten te organiseren",
        "Afwisselend werk met veel variatie",
        "Prettige werksfeer in een klein hecht team",
        "Goede secundaire arbeidsvoorwaarden (CAO Zorg & Welzijn)",
        "Ruimte voor persoonlijke ontwikkeling"
      ]
    }
  ]

  const benefits = [
    {
      icon: <FaUsers />,
      title: "Klein hecht team",
      description: "Werk samen met gedreven collega's in een persoonlijke sfeer"
    },
    {
      icon: <FaGraduationCap />,
      title: "Ontwikkeling",
      description: "We investeren in je persoonlijke en professionele groei"
    },
    {
      icon: <FaHeart />,
      title: "Waardevol werk",
      description: "Maak écht het verschil in het leven van onze cliënten"
    },
    {
      icon: <FaHandshake />,
      title: "Goede voorwaarden",
      description: "Conform CAO Zorg & Welzijn met extra's"
    }
  ]

  return (
    <div className={styles.careersPage}>
      {/* Hero Section */}
      <section className={styles.pageHeader}>
        <div className="container">
          <h1 className="fade-in">Werk & Leren</h1>
          <p className="fade-in-delay">Kom werken waar zorg écht persoonlijk is</p>
        </div>
      </section>

      {/* Intro Section */}
      <section className={styles.introSection}>
        <div className="container">
          <div className={styles.introContent}>
            <div className="fade-in">
              <h2>Werken bij Sobé Zorg Twente</h2>
              <p>
                Bij Sobé Zorg Twente draait alles om persoonlijke aandacht voor onze cliënten. We zijn een kleinschalige 
                organisatie waar iedereen elkaar kent en waar je écht het verschil kunt maken. Ons team bestaat uit 
                gedreven professionals die met passie en toewijding werken aan het welzijn van ouderen.
              </p>
              <p>
                Wij werken voornamelijk met <strong>multiculturele cliënten</strong> die <strong>Suryoyo en/of Arabisch</strong> spreken. 
                Veel van onze cliënten spreken weinig tot geen Nederlands. We zoeken daarom collega's die één of beide van 
                deze talen spreken, of bereid zijn om met taalbarrières te werken door middel van gebarentaal, 
                beeldmateriaal en andere creatieve communicatiemiddelen.
              </p>
              <p>
                We bieden een inclusieve omgeving waar diversiteit gewaardeerd wordt en zoeken collega's die met respect 
                en openheid naar verschillende culturen en achtergronden kijken.
              </p>
              <p>
                Of je nu een ervaren zorgprofessional bent of net aan je carrière begint, bij ons ben je welkom! 
                We bieden een warme werkomgeving waar jouw inbreng gewaardeerd wordt en waar je alle ruimte krijgt 
                om jezelf te ontwikkelen.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section className={styles.benefitsSection}>
        <div className="container">
          <div className={styles.sectionHeader}>
            <h2>Waarom werken bij ons?</h2>
            <p>Dit maakt werken bij Sobé Zorg Twente bijzonder</p>
          </div>
          <div className={styles.benefitsGrid}>
            {benefits.map((benefit, index) => (
              <div key={index} className={`${styles.benefitCard} fade-in`} style={{ animationDelay: `${index * 0.1}s` }}>
                <div className={styles.benefitIcon}>{benefit.icon}</div>
                <h3>{benefit.title}</h3>
                <p>{benefit.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Vacancies Section */}
      <section className={styles.vacanciesSection}>
        <div className="container">
          <div className={styles.sectionHeader}>
            <h2>Huidige vacatures</h2>
            <p>Bekijk onze openstaande functies en solliciteer direct</p>
          </div>

          <div className={styles.vacanciesGrid}>
            {vacancies.map((vacancy) => (
              <div key={vacancy.id} className={`${styles.vacancyCard} fade-in`}>
                <div className={styles.vacancyHeader}>
                  <div>
                    <h3>{vacancy.title}</h3>
                    <div className={styles.vacancyMeta}>
                      <span className={styles.vacancyType}>
                        <FaBriefcase aria-hidden="true" /> {vacancy.type}
                      </span>
                      <span className={styles.vacancyLocation}>
                        <FaMapMarkerAlt aria-hidden="true" /> {vacancy.location}
                      </span>
                      <span className={styles.vacancyHours}>
                        <FaClock aria-hidden="true" /> {vacancy.hours}
                      </span>
                    </div>
                  </div>
                </div>

                <p className={styles.vacancyDescription}>{vacancy.description}</p>

                <div className={styles.vacancyDetails}>
                  <div className={styles.vacancySection}>
                    <h4>Wat vragen wij?</h4>
                    <ul>
                      {vacancy.requirements.map((req, index) => (
                        <li key={index}>
                          <FaCheckCircle aria-hidden="true" /> {req}
                        </li>
                      ))}
                    </ul>
                  </div>

                  <div className={styles.vacancySection}>
                    <h4>Wat bieden wij?</h4>
                    <ul>
                      {vacancy.offer.map((item, index) => (
                        <li key={index}>
                          <FaCheckCircle aria-hidden="true" /> {item}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                <a href={`mailto:info@sobe-zorg.nl?subject=Sollicitatie%20%7C%20${vacancy.title}`} className={styles.applyBtn}>
                  <FaEnvelope aria-hidden="true" /> Solliciteer nu
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Internship Section */}
      <section className={styles.internshipSection}>
        <div className="container">
          <div className={styles.internshipContent}>
            <div className="fade-in">
              <FaGraduationCap className={styles.internshipIcon} />
              <h2>Stage lopen bij Sobé Zorg Twente</h2>
              <p>
                Ben je MBO-student SPH of Sociaal Cultureel Werk? Bij Sobé Zorg Twente bieden we 
                stageplaatsen waar je leert hoe je professionele zorg combineert met persoonlijke aandacht. 
                Je werkt mee in ons team en krijgt begeleiding van ervaren zorgprofessionals.
              </p>
              <p>
                Tijdens je stage doe je praktijkervaring op met dagbesteding, individuele begeleiding en het 
                organiseren van activiteiten voor multiculturele ouderen. Je leert werken met cliënten die 
                Suryoyo en/of Arabisch spreken en weinig tot geen Nederlands.
              </p>
              <p>
                <strong>Geïnteresseerd in een stageplaats?</strong> Neem contact met ons op via onderstaande 
                knop om de mogelijkheden te bespreken.
              </p>
              <div className={styles.ctaButtons}>
                <a href="mailto:info@sobe-zorg.nl?subject=Informatie%20stageplaats%20MBO" className={styles.btnPrimary}>
                  <FaEnvelope aria-hidden="true" /> Informatie aanvragen
                </a>
                <Link to="/contact" className={styles.btnSecondary}>
                  Contact opnemen
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Open Application CTA */}
      <section className={styles.openApplicationSection}>
        <div className="container">
          <div className={styles.ctaBox}>
            <h2>Staat jouw droombaan er niet bij?</h2>
            <p>
              Stuur ons een open sollicitatie! We zijn altijd op zoek naar gedreven professionals die ons team 
              willen versterken. Vertel ons wie je bent en wat je te bieden hebt.
            </p>
            <a href="mailto:info@sobe-zorg.nl?subject=Open%20sollicitatie" className={styles.btnPrimary}>
              <FaEnvelope aria-hidden="true" /> Open sollicitatie versturen
            </a>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Careers
